import Exam from "../../api/v2/models/exam"

export default Exam